import { createSlice, PayloadAction } from "@reduxjs/toolkit";
// Define a type for the slice state

// Define the initial state using that type

const allShiftsLists = createSlice({
  name: "shiftLists",

  initialState: {
    shiftLists: [],
    trigger: "no",
  },
  reducers: {
    setAllShiftListsData: (state: any, action: PayloadAction<any>) => {
      const payload = action.payload;
      state.shiftLists = payload;
    },
    updateShiftListTrigger: (state: any, action: PayloadAction<any>) => {
      const payload = action.payload;
      state.trigger = payload;
    },

    resetAllShiftListsData: (state: any) => {
      state = [];
    },
  },
});

export const {
  resetAllShiftListsData,
  setAllShiftListsData,
  updateShiftListTrigger,
} = allShiftsLists.actions;

// // Other code such as selectors can use the imported `RootState` type
// export const selectCount = (state: RootState) => state.counter.value

export default allShiftsLists.reducer;
